export default function AutomationIcon({ color }: { color: string }) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2581 9.17647C12.2581 6.81909 14.1469 4.94118 16.4357 4.94118C17.4999 4.94118 18.4728 5.34422 19.2133 6.01305L19.8758 5.32465C18.9663 4.50316 17.7602 4 16.4357 4C13.7022 4 11.4935 6.13042 11.3003 8.7963L7.61231 9.15357C7.27311 8.60358 6.65249 8.23529 5.94307 8.23529C4.86994 8.23529 4 9.07805 4 10.1176C4 11.1572 4.86994 12 5.94307 12C6.16841 12 6.38479 11.9628 6.58603 11.8945L11.8063 19.0588H4.97154V20H20.5161V19.0588H12.9955L7.39335 11.3704C7.69986 11.0376 7.88615 10.5987 7.88615 10.1176C7.88615 10.1027 7.88597 10.0878 7.88561 10.073L11.3169 9.74056C11.5958 12.3198 13.7653 14.3529 16.4357 14.3529C17.7602 14.3529 18.9663 13.8498 19.8758 13.0283L19.2133 12.3399C18.4728 13.0087 17.4999 13.4118 16.4357 13.4118C14.3015 13.4118 12.5149 11.7788 12.2834 9.64693L12.3064 9.6447L12.2581 9.17647ZM5.94307 11.0588C6.47964 11.0588 6.91461 10.6374 6.91461 10.1176C6.91461 9.59784 6.47964 9.17646 5.94307 9.17646C5.40651 9.17646 4.97154 9.59784 4.97154 10.1176C4.97154 10.6374 5.40651 11.0588 5.94307 11.0588Z"
          fill={color}
        />
      </svg>
    </>
  );
}
